// wf-link-validator.directive.js

/**
 * @returns {any}
 */
export default function contextLinkValidatorDirective() {
	return {
		restrict: 'A',
		require: [
			'ngModel',
			'^^uploadClassicLinks',
		],
		/**
		 * @param {import('angular').IScope} scope
		 * @param {import('angular').IRootElementService} _element
		 * @param {import('angular').IAttributes} attributes
		 * @param {[import('angular').INgModelController, import('./upload-classic-links.controller').default]} ctrl
		 */
		link: (scope, _element, attributes, ctrl) => {
			const [ngModel, uploadClassicLinkController	] = ctrl;
			// On récupère l'objet "ctx" passé dans l'attribut via $eval
			// attrs.ctxLinkValidator contient la chaîne "ctx"
			const getContext = () => scope.$eval(attributes.ctxLinkValidator);

			// On ajoute une fonction au dictionnaire $validators de ngModel
			ngModel.$validators.required = () => {
				let valid = true;
				const context = getContext();
				const links = uploadClassicLinkController.file?.links.filter(
					l => l.class_kid === context.node && l.linker_kid === context.linker_kid,
				) ?? [];
				if (links.length < context.card.from || links > context.card.to) {
					valid = false;
				}
				uploadClassicLinkController.error = !valid;
				return valid;
			};

			// Optionnel : Re-valider si les données du contexte changent
			scope.$watch(() => uploadClassicLinkController.file?.links, () => {
				ngModel.$validate();
			}, true);
		}
	};
}
